// removed by extract-text-webpack-plugin
module.exports = {"argument":"theme__argument___1KWoX","argumentImage":"theme__argumentImage___vL2F6","imageLoaded":"theme__imageLoaded___1pe6z","fadeUp":"theme__fadeUp___3Kux9","argumentText":"theme__argumentText___2Cr12","lateFadeIn":"theme__lateFadeIn___1DugP","lateFadeUp":"theme__lateFadeUp___nJr5s"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Question/Argument/theme.scss
// module id = 482
// module chunks = 0